/**
 * Shared copy for vault end states (liquidated/exited) - used by the global
 * banner notice, the vault stats panel and the vault detail page, so all the
 * texts stay in one place.
 */
export const vaultEndStateCopy = {
  liquidated: {
    label: 'Liquidated',
    /** Short message - global banner notice */
    message: 'This vault is no longer accepting deposits or generating yield.',
    /** Vault detail page notice */
    detailMessage: (formattedTime: string | undefined) =>
      formattedTime
        ? `This vault has been liquidated on ${formattedTime}. No funds are available to withdraw.`
        : // Fallback (should not be used)
          `This vault has been liquidated. No funds are available to withdraw.`,
  },
  exited: {
    label: 'Exited',
    /** Short message - global banner notice */
    message: 'This vault is no longer accepting deposits or generating yield.',
    /** Vault detail page notice */
    detailMessage: (formattedTime: string | undefined) =>
      formattedTime
        ? `This vault has exited on ${formattedTime}. Withdraw now to claim your share of remaining funds.`
        : // Fallback (should not be used)
          `This vault has exited. Withdraw now to claim your share of remaining funds.`,
  },
} as const;
